import styled from "styled-components";

import { Flex, Text } from "@similarweb/ui-components/foundations";

const Container = styled(Flex)`
    gap: 8px;
`;

export const YAxisContainer = styled(Container)`
    height: 100%;
    flex-direction: column;
    justify-content: center;
`;

export const YAxisContent = styled(Text)`
    writing-mode: vertical-lr;
    text-orientation: sideways;
    transform: rotate(180deg);
`;

export const YAxisTooltipContainer = styled.div`
    transform: rotate(270deg);
`;

export const XAxisContainer = styled(Container)`
    justify-content: center;
    margin-left: 60px;
    width: calc(100% - 60px);
`;

export const XAxisTooltipContainer = styled.div`
    margin-top: 1px;
`;
